import { FunctionComponent, ReactElement } from 'react';
import { Portfolio } from '@/app/api/portfolio-considerations';
import { Column, Pagination, Table } from '@/components/ui/table';
import { getPortfolioMandateScore } from '../../../client/portfolio-considerations/portfolio-considerations.utils';
import { DEFAULT_PAGE_SIZE } from './portfolio-table.constants';
import LinkCell from './cells/dialogues-portal-cell';
import { Paginated } from '@/app/api';

interface PortfoliosTableProps {
	data?: Paginated<Portfolio>;
	onPageChange: (page: number) => void;
}

const PortfoliosTable: FunctionComponent<PortfoliosTableProps> = ({
	data,
	onPageChange,
}): ReactElement => {
	const {
		content: rows = [],
		totalElements: totalItems = 0,
		pageable: { pageNumber = 0, pageSize = DEFAULT_PAGE_SIZE } = {},
	} = data || {};

	const columns: Column<Portfolio>[] = [
		{
			name: 'Name',
			accessors: ['name'],
		},
		{
			name: 'Model Exp | Min',
			accessors: ['symbol'],
		},
		{
			name: 'Mandate Score',
			render: (portfolio) => getPortfolioMandateScore(portfolio),
		},
		{
			name: 'Link',
			render: ({ linkUrl, linkText }) => <LinkCell url={linkUrl} label={linkText} />,
		},
	];

	const pagination: Pagination = {
		count: totalItems,
		page: pageNumber,
		rowsPerPage: pageSize,
		onPageChange,
	};

	return <Table<Portfolio> columns={columns} rows={rows} pagination={pagination} />;
};

export default PortfoliosTable;
